import {gql} from "@apollo/client";

export const GET_SANCTION_RULES = gql`
query SanctionRules($page: Int, $pageSize: Int) {
  sanctionRules(page: $page, pageSize: $pageSize) {
    objects {
      id
      name
      maxAccumulatedYellowCards
      redCardSuspensionGames
      yellowCardSuspensionGames
      doubleYellowCardSuspensionGames

      resetYellowCardsOnRed
      resetYellowCardsOnStageChange
      resetSanctionsOnStageChange
      resetYellowCardsOnDoubleYellow
      doubleYellowCardOverridesAccumulation

      yellowCardFine
      redCardFine
      doubleYellowCardFine

      createdBy {
        email
      }
    }
    page
    pages
    hasNext
    hasPrev
  }
}
`;


export const CREATE_SANCTION_RULE = gql`
mutation CreateSanctionRule($input: CreateSanctionRuleInput!) {
  createSanctionRule(input: $input) {
    sanctionRule {
      id
      name
      maxAccumulatedYellowCards
      redCardSuspensionGames
      yellowCardSuspensionGames
      doubleYellowCardSuspensionGames

      resetYellowCardsOnRed
      resetYellowCardsOnStageChange
      resetSanctionsOnStageChange
      resetYellowCardsOnDoubleYellow
      doubleYellowCardOverridesAccumulation

      yellowCardFine
      redCardFine
      doubleYellowCardFine

      createdBy {
        email
      }
    }
  }
}
`;


export const UPDATE_SANCTION_RULE = gql`
mutation UpdateSanctionRule($id: ID!, $input: CreateSanctionRuleInput!) {
  updateSanctionRule(id: $id, input: $input) {
    sanctionRule {
      id
      name
      maxAccumulatedYellowCards
      redCardSuspensionGames
      yellowCardSuspensionGames
      doubleYellowCardSuspensionGames

      resetYellowCardsOnRed
      resetYellowCardsOnStageChange
      resetSanctionsOnStageChange
      resetYellowCardsOnDoubleYellow
      doubleYellowCardOverridesAccumulation

      yellowCardFine
      redCardFine
      doubleYellowCardFine

      createdBy {
        email
      }
    }
  }
}
`;


export const DELETE_SANCTION_RULE = gql`
mutation DeleteSanctionRule($id: ID!) {
    deleteSanctionRule(id: $id) {
      success
    }
  }
`